import useAuthUser from "../../../common/hooks/authUser";
import {Breadcrumbs, ToastContainer} from "../../../components/Common";
import Quotes from "./components/Quotes";
import Jobs from "./components/Jobs";
import Devices from "./components/Devices";
import DevicesTotals from "./components/DevicesTotals";
import {Container} from "reactstrap";
import { useState } from "react";
import DeviceFormModal from "../Devices/components/form/index";

const DashboardWrapper = () => {
    //meta title
    document.title = "My Dashboard";

    const { user } = useAuthUser();
    const [showDeviceForm, setShowDeviceForm] = useState(false);
    const SHOW_QUOTES_AND_JOBS = false;

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Dashboard"
                    >
                        <button
                        className="ms-4 btn btn-primary"
                        onClick={() => setShowDeviceForm(true)}
                        >
                            REGISTER MACHINE
                        </button>
                    </Breadcrumbs>
                </Container>
                <Devices userId={user.id} />
                <DevicesTotals userId={user.id} />
                
                
                {SHOW_QUOTES_AND_JOBS && <Quotes userId={user.id} />}
                {SHOW_QUOTES_AND_JOBS && <Jobs />}


            </div>

            <ToastContainer />
            <DeviceFormModal
                isOpen={showDeviceForm}
                onClose={() => setShowDeviceForm(false)}
            />
        </>
    );
};

export default DashboardWrapper;
